import config from "../../app.json";
import axios from "axios";

import "./event-card.scss";
import React, { useEffect, useState, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import EventIcon from "../../Assets/Images/event-icon.svg";
import { Context } from "../../Reducers/Store";
import channelIcon from "../../Assets/Images/videoplay.png";
import clocklIcon from "../../Assets/Images/clock.png";
import android from "../../Assets/Images/gear.svg";

import ChannelStatus from "../ChannelStatus/channel-status";
import moment from 'moment';

import ChurchModal from "../ChurchModal";
import AlertComponent from "../AlertComponent";


function EventCard(props) {
  const [state, dispatch] = useContext(Context);
  const { id, name, place, startTime, channelId, startDate, autoStart, fetchChannelData, deleteApiPath, deleteMessage, onDelete, isView } = props;
  const [status, setStatus] = useState(null);
  const [deleteItem, setDeleteItem] = useState({ invisible: false });
  const [urlImage, setUrlImage] = useState(null);
  const [wait, setWait] = useState(false);

  let navigate = useNavigate();

  useEffect(() => {
    if (state.channelStatus != null) {
      setStatus(state.channelStatus[channelId] ?? "Loading...");
    }
  }, [state.channelStatus]);

  useEffect(() => {
    if (channelId) {
      if (fetchChannelData == true) {
        fetchChannelThumbnail();
      }
    }

    return () => {
      if (urlImage != null)
        URL.revokeObjectURL(urlImage);
    }
  }, [channelId]);

  const handleManage = () => {
    return navigate(`/manageEvent/${id}`, { state: { isView: isView } });
  };

  const setInvis = (invis) => {
    setDeleteItem({ invisible: invis });
  };

  const handleRemove = (id, name) => {
    setDeleteItem({
      invisible: true,
      setInvisible: (invis) => setInvis(invis),
      title: name,
      content: `You're about to delete an event. Are you sure you want to continue?`,
      createItem: `Confirm`,
      discardItem: `Cancel & Close`,
      onSubmit: () => removeChannel(id),
      messageTitle: `Success`,
      message: deleteMessage,
    });
  };

  const removeChannel = (id) => {
    axios
      .post(config.API + deleteApiPath, {
        id: id,
      })
      .then((res) => {
        if (res.status === 200) {
          if (onDelete) {
            onDelete();
          }
          return;
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };


  const fetchChannelThumbnail = () => {
    axios.post(config.API + "/api/channel/getChannelThumbnail", { id: channelId }, { responseType: 'blob' }).then((res) => {
      if (res.status === 200 && res.data) {
        // criar um objeto URL para a resposta da imagem
        setUrlImage(URL.createObjectURL(res.data));
      }
    }).catch(function (error) {
      setUrlImage(null);
    });
  }

  const fetchStart = () => {
    AlertComponent("Confirm", "Do you really want to start this event?", { showCancelButton: true }, (e) => {
      if (e.isConfirmed) {
        window._wait[channelId] = "STARTING";
        setTimeout(() => {
          window._wait[channelId] = null;
        }, 30000);

        axios.post(config.API + "/api/event/startEvent", { id: id }).then((res) => {
          console.log("starting...");
        }).catch(function (error) {
          window._wait[channelId] = null;
        });
      }
    }, false, "Yes");
  }

  const fetchStop = () => {
    AlertComponent("Confirm", "Do you really want to stop this event?", { showCancelButton: true }, (e) => {
      if (e.isConfirmed) {
        window._wait[channelId] = "STOPPING";
        setTimeout(() => {
          window._wait[channelId] = null;
        }, 30000);
        axios.post(config.API + "/api/event/stopEvent", { id: id }).then((res) => {
          console.log("stopping...");
        }).catch(function (error) {
          window._wait[channelId] = null;
        });
      }
    }, false, "Yes");
  }

  return (
    <div className="event-card-content">
      <div className="event-thumb-container">
        <div style={{ position: 'absolute', top: 15, left: 15 }}>
          {status == "RUNNING" && <Button onClick={fetchStop} className="btn-press btn-mini-stop">
            Stop
          </Button>}

          {status == "IDLE" && <Button onClick={fetchStart} className="btn-press btn-mini-start">
            Start
          </Button>}
        </div>
        <ChurchModal {...deleteItem} />
        {urlImage == null && <div

          style={{
            width: 50,
            height: 55,
            backgroundImage: "url(" + EventIcon + ")",
            backgroundSize: "cover",
          }}
        ></div>}

        {urlImage && <div
          className="elemental-link-preview"
          style={{
            width: '100%',
            height: '100%',
            backgroundImage: "url(" + urlImage + ")",
            backgroundSize: "105%",
            borderRadius: 20,
            overflow: 'hidden',
            backgroundPosition: 'center'
          }}
        ><span className="device"></span></div>}

      </div>

      <div className="event-card-body">
        <div className="event-meta">
          <p className="event-card-name">{name}</p>
          <p className="event-card-element"><img className="icon" src={channelIcon} />{`Channel: ${place}`}</p>
          {startTime && <p className="event-card-element"><img className="icon" src={clocklIcon} />{`Starts: ${moment(startDate).format('MM/DD')} ${moment(startTime, 'HH:mm:ss').format('h:mm A')}`}</p>}
          <p className="event-card-element"><img className="icon" src={android} />{autoStart ? "Auto Start" : "Manual Start"}</p>
          {deleteApiPath && <p className="event-card-element"><span style={{ width: 14, height: 13, marginRight: 6, backgroundColor: '#F8DD95', borderRadius: 7 }}></span>{status}</p>}
        </div>
        <Row className="event-actions">
          <Col className="col-md-6">
            {id && state.profile.role == "ROLE_CHURCH_ADMIN" && <Button className={isView ? `button-view` : `button-manage`} onClick={handleManage}>
              {isView ? "View" : "Manage"}
            </Button>
            }
          </Col>

          {!deleteApiPath && <Col className="col-md-6 d-flex justify-content-end flex-column align-content-end align-items-end">
            <div className="channel-status">Channel Status</div>
            <ChannelStatus status={status} />
          </Col>}

          {deleteApiPath && state.profile.role == "ROLE_CHURCH_ADMIN" && <Col className="col-md-6 d-flex justify-content-end">
            <Button
              className={`button-remove`}
              onClick={() => handleRemove(id, name)}
            >
              Remove
            </Button>
          </Col>
          }
        </Row>
      </div>
    </div>
  );
}

export default EventCard;
